import { Category } from "scenes/cohort-filters/filter-configs/categories";
import { WidgetType } from "scenes/cohort-filters/filter-configs/widgetTypes";

export const rangeFieldConfigConstructor = ({
    pathToValue,
    category = Category.OTHER,
    label,
    isDate,
    fieldWidth = null,
    nestedComponent = false,
}) => ({
    [pathToValue]: {
        widgetType: WidgetType.RANGE_FILTER,
        category: nestedComponent ? undefined : category,
        widgetConfig: {
            label: label,
            isDate,
            width: fieldWidth,
        },
    },
});
